'use client';

import { UseQueryOptions } from '@tanstack/react-query';

import { mergeCustomerWithMember } from './customer-query-util';
import { useQueryCustomer } from './use-query-customer';
import { useQueryMember } from './use-query-member';

export const useQueryCustomerMember = (
  currentCustomerId?: string,
  currentMemberId?: string,
  options: Omit<UseQueryOptions<MarketingCustomer | null, Error, MarketingCustomer | null>, 'queryKey'> = {}
) => {
  const customerQuery = useQueryCustomer(currentCustomerId, options);

  // Resolve memberId: explicit param > redux (handled inside useQueryMember) > customer-derived
  const derivedMemberId = currentMemberId || customerQuery.data?.member?.id;
  const memberQuery = useQueryMember(derivedMemberId);

  const data = customerQuery.data
    ? mergeCustomerWithMember(customerQuery.data, memberQuery.data ?? null)
    : null;

  return {
    data,
    isLoading: customerQuery.isLoading || memberQuery.isLoading,
    isFetching: customerQuery.isFetching || memberQuery.isFetching,
    isError: customerQuery.isError || memberQuery.isError,
    error: customerQuery.error || memberQuery.error,
    isPending: customerQuery.isPending || memberQuery.isPending,
    isSuccess: customerQuery.isSuccess && (!derivedMemberId || memberQuery.isSuccess),
    refetch: () => Promise.all([customerQuery.refetch(), memberQuery.refetch()])
  };
};
